// Coordonnées, horaires et liens de la concession.
// Sources : ancien site harley-davidson-caen.com, ses conditions générales et
// ses newsletters 2022-2024, et l'Annuaire des entreprises (data.gouv.fr).
// Détail dans docs/audit-ancien-site.md. Ce qui est marqué « à confirmer »
// doit être validé par la concession.

export const SITE_URL = "https://harley-davidson-caen.com";

export const DEALER = {
  name: "Harley-Davidson Caen",
  zone: "ZAC Object'Ifs Sud",
  street: "941 boulevard Charles Cros",
  postalCode: "14123",
  city: "Ifs",
  region: "Normandie",
  // Base Adresse Nationale (api-adresse.data.gouv.fr)
  geo: { lat: 49.144913, lng: -0.332264 },
  phone: "02 31 35 50 20",
  phoneIntl: "+33231355020",
  email: "contact@harley-davidson-caen.com",
  social: [
    { label: "Facebook", url: "https://www.facebook.com/Harley-Davidson-CAEN-222870314396678/" },
    { label: "Instagram", url: "https://www.instagram.com/harleydavidsoncaen/" },
    { label: "YouTube", url: "https://www.youtube.com/channel/UCoLM5L4QCDzm3EVVckeyl9A" },
    { label: "LinkedIn", url: "https://www.linkedin.com/company/harley-davidson-caen/" },
  ],
};

// Société exploitante : Annuaire des entreprises (data.gouv.fr), consulté le
// 3 octobre 2026, et conditions générales de réparation (décembre 2023).
export const COMPANY = {
  legalName: "ASPHALT SPIRIT",
  form: "SARL",
  capital: "30 500 €",
  siren: "430 434 035",
  siret: "430 434 035 00035",
  rcs: "RCS Caen 430 434 035", // greffe déduit du siège : à vérifier sur l'extrait Kbis
  vat: "FR93 430 434 035",
  manager: "Cyril Ragot", // gérant
};

// Jours : 1 = lundi … 7 = dimanche. Plages en heures décimales.
// `except` : mois (1-12) où la plage ne s'applique pas.
// Jours fériés et fermetures exceptionnelles : src/data/closures.js.
export const HOURS = {
  shop: {
    label: "Magasin et showroom",
    days: [
      { day: 2, slots: [[10, 12], [14, 18]] },
      { day: 3, slots: [[9, 12], [14, 18]] },
      { day: 4, slots: [[9, 12], [14, 18]] },
      { day: 5, slots: [[9, 12], [14, 18]] },
      { day: 6, slots: [[10, 19]] },
    ],
  },
  workshop: {
    label: "Atelier",
    days: [
      { day: 1, slots: [[10, 12], [13, 18]], except: [7, 8], note: "sauf juillet et août" },
      { day: 2, slots: [[10, 12], [14, 18]] },
      { day: 3, slots: [[9, 12], [14, 18]] },
      { day: 4, slots: [[9, 12], [14, 18]] },
      { day: 5, slots: [[9, 12], [14, 18]] },
      { day: 6, slots: [[10, 19]] },
    ],
  },
};

// Liens officiels Harley-Davidson et partenaires (vérifiés le 3 octobre 2026).
export const LINKS = {
  testRide: "https://testrides.harley-davidson.com/fr_FR/?d=6976",
  // Demande de location, concession de Caen présélectionnée
  rental: "https://rentals.harley-davidson.com/fr_FR?v=TSD&locale=fr_FR&pickuploc=202304",
  shop: "https://boutique.harley-davidson-caen.com/",
  // Stock H-D Certified dans un rayon de 20 km autour d'Ifs : uniquement Harley-Davidson Caen
  certified: "https://occasion.harley-davidson.fr/fr/bikes/page/1/PostCode=14123_20+OrderBy=distance/",
  financing: "https://www.harley-davidson.com/fr/fr/tools/motorcycle-financing.html",
  calculator: "https://calculator.harley-davidson.com/landing",
  insurance: "https://offre.harley-assurance.com/moto",
  range: "https://www.harley-davidson.com/fr/fr/motorcycles/index.html",
  hog: "https://www.harley-davidson.com/fr/fr/content/hog.html",
  // Pages officielles reprises par le site (voir docs/audit-site-officiel.md)
  offers: "https://www.harley-davidson.com/fr/fr/tools/offers.html",
  brochure: "https://brochure.harley-davidson.com/fr_FR",
  insuranceInfo: "https://www.harley-davidson.com/fr/fr/tools/insurance-services.html",
  warranty: "https://www.harley-davidson.com/fr/fr/tools/warranty-services.html",
  authorizedService: "https://www.harley-davidson.com/fr/fr/content/motorcycle-maintenance/authorized-service.html",
  serviceInfo: "https://serviceinfo.harley-davidson.com/lookup", // manuels, entretien, rappels (par numéro de série)
  infotainment: "https://www.h-d.com/infotainment-support", // mises à jour logicielles
  ridePlanner: "https://maps.harley-davidson.com",
  app: "https://www.harley-davidson.com/fr/fr/content/h-d-app.html",
};

// Équipe telle que publiée sur l'ancien site (page « Notre équipe »).
// À confirmer : liste à jour et accord de chacun avant publication.
export const TEAM = [
  { name: "Cyril Ragot", role: "Directeur général" },
  { name: "Stéphanie", role: "Directrice commerciale" },
  { name: "Manu Cigaia", role: "Responsable des ventes" },
  { name: "Astrid", role: "Apprentie commerciale" },
  { name: "Pierre-Yves", role: "Responsable après-vente" },
  { name: "Armand", role: "Technicien" },
  { name: "Pierre", role: "Technicien" },
  { name: "Maxence", role: "Apprenti technicien" },
];
export const MASCOTS = ["Sookie, la mascotte junior", "Iron, la mascotte senior"];

// Événements passés : agenda de l'ancien site et newsletters 2022-2024.
// `date` au jour (AAAA-MM-JJ) ou au mois (AAAA-MM) quand le jour n'est pas connu.
export const PAST_EVENTS = [
  { date: "2024-03-28", end: "2024-03-30", title: "Ventes privées avec Honda Caen", place: "Harley-Davidson Caen et Honda Caen" },
  { date: "2024-03-17", title: "Salon de la moto de Coutances", place: "Coutances" },
  { date: "2023-12-15", end: "2023-12-16", title: "Marché de Noël d'Ifs", place: "Ifs", note: "Avec le stand photo du chapter, au profit de l'association « Les fées Papillons »." },
  { date: "2023-11-17", end: "2023-11-19", title: "Salon auto-moto de Caen", place: "Parc des expositions de Caen" },
  { date: "2023-10", title: "Octobre rose", place: "Mondeville 2" },
  { date: "2023-09-12", title: "Journée d'essai de la LiveWire ONE", place: "Harley-Davidson Caen, Ifs" },
  { date: "2023-09", title: "Normandy Beach Race", place: "Sword Beach, Ouistreham", note: "La concession participait à la course." },
  { date: "2023-09-02", end: "2023-09-03", title: "Retrofestival", place: "Hippodrome de Caen", note: "Avec la WLA de 1942 de la concession." },
  { date: "2023-06-17", title: "Les 120 ans de Harley-Davidson", place: "Harley-Davidson Caen, puis Ford Caen à Hérouville-Saint-Clair", note: "Run du chapter, barbecue, concert, puis soirée avec Ford Caen." },
  { date: "2023-05-28", title: "Balade Welcome New Riders", place: "Départ de la concession" },
  { date: "2023-05-12", end: "2023-05-13", title: "Journées portes ouvertes", place: "Harley-Davidson Caen, Ifs", note: "Essais de la gamme, ateliers avec Ifs auto-école, baptêmes moto." },
  { date: "2023-03-31", end: "2023-04-01", title: "Harley Welcome Days", place: "Harley-Davidson Caen, Ifs", note: "Essais des nouveaux modèles et de la gamme Touring." },
  { date: "2023-03-26", title: "Balade Welcome New Riders", place: "Départ de la concession" },
  { date: "2023-03-18", title: "Balade de la journée internationale des droits des femmes", place: "Départ de la concession, visite à Bayeux", note: "Avec le chapter Caen Côte de Nacre, toutes marques bienvenues." },
  { date: "2022-12-09", title: "Soirée d'information West Forever", place: "Harley-Davidson Caen, Ifs", note: "Voyages à moto aux États-Unis." },
  { date: "2022-12-03", end: "2022-12-04", title: "Vintage Christmas par l'OSK Summer Day", place: "Parc des expositions de Lisieux" },
  { date: "2022-11-18", end: "2022-11-20", title: "Salon auto-moto de Caen", place: "Parc des expositions de Caen" },
  { date: "2022-10-16", title: "Octobre rose avec le chapter Caen Côte de Nacre", place: "Départ de la concession, arrivée à Baron-sur-Odon", note: "40 motos, 53 participants et 647 € reversés au centre François Baclesse." },
  { date: "2022-09-23", title: "Rendez-vous des électromobiles", place: "Centrale EDF de Flamanville" },
  { date: "2022-09-18", title: "Balade Welcome New Riders", place: "Départ de la concession, vers le Tilly American Festival" },
  { date: "2022-09-10", end: "2022-09-11", title: "OSK Summer Day", place: "Hippodrome de Dozulé" },
];

// Albums de la galerie photos de l'ancien site (titres seulement).
export const PAST_GALLERY = [
  "Salon auto-moto, parc des expositions de Caen",
  "Octobre rose",
  "Soirée Sportster S",
  "Normandy Beach Race 2021",
  "Les Belles de May",
  "Chromes & Roses : soirée « Only girls »",
  "Soirée Harley-Davidson / Mercedes : « Juste pour lui »",
  "D-Day en Normandie avec les pilotes du Air Crew 731 AS Colorado Springs",
  "Festival du cinéma américain 2020",
  "Normandy Beach Race 2020",
];
